import { render, staticRenderFns } from "./NodeAdd.vue?vue&type=template&id=01016262&scoped=true"
import script from "./NodeAdd.vue?vue&type=script&lang=js"
export * from "./NodeAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01016262",
  null
  
)

export default component.exports